import Modal from 'antd/es/modal';

export default Modal;
